module.exports = __webpack_public_path__ + "474d9e8b0a8705a533d7b4e870e1147b.svg";